<template>
  <div>
    <div class="columns">
      <div class="column">
        <sc-field
          label="Período"
          prop="date_range">
          <sc-range-date-picker
            v-model="filters.date_range"
            :max-date="getMaxDate()"
            :format="formatDate"
            @input="filterChanged"
            />
        </sc-field>
      </div>

      <div class="column">
        <sc-field
          label="Origem"
          prop="module">
          <sc-select
            v-model="filters.module"
            @input="originChanged"
            expanded>
            <option :value="null">Todas</option>
            <option
              v-for="originFilter in originFilters"
              :value="originFilter.name"
              :key="originFilter.name">
              {{ originFilter.name }}
            </option>
          </sc-select>
        </sc-field>
      </div>

      <div class="column">
        <sc-field
          label="O que mudou?"
          prop="module">
          <sc-select
            v-model="filters.what_has_changed"
            @input="filterChanged"
            expanded>
            <option selected :value="null">Todas</option>
            <option
              v-for="whatChangedFilter in currentWhatChangedFilters"
              :value="whatChangedFilter.name"
              :key="whatChangedFilter.name">
              {{ whatChangedFilter.name }}
            </option>
          </sc-select>
        </sc-field>
      </div>

      <div class="column">
        <sc-field
          label="Ação"
          prop="action">
          <sc-select
            v-model="filters.action"
            @input="filterChanged"
            expanded>
            <option :value="null">Todas</option>
            <option
              v-for="actionFilter in actionFilters"
              :value="actionFilter.name"
              :key="actionFilter.name">
              {{ actionFilter.name }}
            </option>
          </sc-select>
        </sc-field>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <sc-field
          label="Status"
          prop="status">
          <sc-select
            v-model="filters.status"
            @input="filterChanged"
            expanded>
            <option :value="null">Todos</option>
            <option
              v-for="statusFilter in statusFilters"
              :value="statusFilter.name"
              :key="statusFilter.name">
              {{ statusFilter.name }}
            </option>
          </sc-select>
        </sc-field>
      </div>

      <div class="column">
        <sc-field
          label="Identificador"
          prop="identity_change">
          <sc-input
            v-model="filters.identity_change"
            @input="filterChanged" />
        </sc-field>
      </div>

      <div class="column">
        <sc-field
          label="Autor"
          prop="author_email">
          <sc-input
            v-model="filters.author_email"
            @input="filterChanged" />
        </sc-field>
      </div>
    </div>
  </div>
</template>

<script>
  import { Moment } from '@intelipost-js/secure-providers';
  import {
    ScField,
    ScRangeDatePicker,
    ScSelect,
    ScInput,
  } from '@intelipost-js/secure-components';
  import logsUserFilters from '../../enum/logsUserFilters.enum';


export default {
    name: 'sc-logs-user-filters',
    data() {
      return {
        ...logsUserFilters,
      };
    },
    props: {
      filters: {
        type: Object,
        required: true,
      },
    },
    methods: {
      getMaxDate() {
        const { currentDate } = this.$store.state.date;
        return Moment(currentDate).toDate();
      },
      formatDate({ start, end }) {
        return {
          start: Moment(start).format('YYYY-MM-DD'),
          end: Moment(end).format('YYYY-MM-DD'),
        };
      },
      originChanged() {
        this.filterChanged();
        delete this.filters.what_has_changed;
      },
      filterChanged() {
        this.$emit('change-filters');
      },
    },
    computed: {
      currentWhatChangedFilters() {
        const currentOrigin = this.originFilters
          .find(origin => origin.name === this.filters.module);
        return (currentOrigin && currentOrigin.whatChangedFilters) || [];
      },
    },
    components: {
      ScField,
      ScRangeDatePicker,
      ScSelect,
      ScInput,
    },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/user/components/sc-logs-user-filters/ScLogsUserFilters.vue?b95c9210